import React from 'react';

export default function SubscribeIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';
  const fillAccent = active ? 'rgba(255,215,0,0.15)' : 'rgba(255,215,0,0.06)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Star */}
      <path
        d="M12 2l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.3 6.2 19.9l1.1-6.5L2.6 8.8l6.5-.9L12 2z"
        fill={fillAccent}
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
